interface CloudWithMachineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloudWithMachineSVG = ({ color, style }: CloudWithMachineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1477_5176)">
      <path
        d="M46.4525 30.2108C49.4055 28.2319 51.3464 24.8743 51.3464 21.0611C51.3464 14.9752 46.3984 10.0428 40.2934 10.0428C40.0059 10.0428 39.7209 10.0575 39.4384 10.0795C36.9743 4.74546 31.5693 1.04004 25.2923 1.04004C17.4871 1.04004 11.0233 6.76594 9.89814 14.2331C5.28432 14.6005 1.65321 18.4479 1.65321 23.1403C1.65321 28.0776 5.66758 32.0794 10.6204 32.0794C10.6671 32.0794 10.7138 32.0769 10.7605 32.0769L16.6641 32.0794"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3937 15.1768H22.253C21.5583 15.1768 20.9951 15.7382 20.9951 16.4307V21.9802C20.9951 22.6728 21.5583 23.2342 22.253 23.2342H41.3937C42.0884 23.2342 42.6516 22.6728 42.6516 21.9802V16.4307C42.6516 15.7382 42.0884 15.1768 41.3937 15.1768Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.502 19.2056H38.7572"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3913 23.2368C42.0865 23.2368 42.6491 23.7977 42.6491 24.4907V30.0403C42.6491 30.7334 42.0865 31.2942 41.3913 31.2942H22.253C21.5577 31.2942 20.9951 30.7334 20.9951 30.0403V24.4907C20.9951 23.7977 21.5577 23.2368 22.253 23.2368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.502 27.2656H38.7572"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3913 31.2939C42.0865 31.2939 42.6491 31.8548 42.6491 32.5479V38.0974C42.6491 38.7905 42.0865 39.3513 41.3913 39.3513H22.253C21.5577 39.3513 20.9951 38.7905 20.9951 38.0974V32.5479C20.9951 31.8548 21.5577 31.2939 22.253 31.2939"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.502 35.3228H38.7572"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8232 39.79V45.6678"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8227 50.3478C33.0438 50.3478 34.0338 49.3609 34.0338 48.1436C34.0338 46.9263 33.0438 45.9395 31.8227 45.9395C30.6015 45.9395 29.6116 46.9263 29.6116 48.1436C29.6116 49.3609 30.6015 50.3478 31.8227 50.3478Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0099 50.3478C24.2311 50.3478 25.221 49.3609 25.221 48.1436C25.221 46.9263 24.2311 45.9395 23.0099 45.9395C21.7888 45.9395 20.7988 46.9263 20.7988 48.1436C20.7988 49.3609 21.7888 50.3478 23.0099 50.3478Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.862 39.79V43.3412L24.9482 46.2458"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.638 50.3478C41.8592 50.3478 42.8491 49.3609 42.8491 48.1436C42.8491 46.9263 41.8592 45.9395 40.638 45.9395C39.4169 45.9395 38.4269 46.9263 38.4269 48.1436C38.4269 49.3609 39.4169 50.3478 40.638 50.3478Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.7853 39.79V43.3412L38.6965 46.2458"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1477_5176">
        <rect width="53" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudWithMachineSVG;
